import React from 'react'

import { useQuizContext } from 'store/QuizStore'
import { nextQuestion, previousQuestion } from 'store/actions'

import { Root, NavButton } from './NavigationBar.styled.js'

const canNavigate = (answer, type) => {
  if (answer === null) {
    return false
  } else {
    return type === 'draw' ? answer.filter(a => a === null).length === 0 : answer !== null
  }
}
const NavigationBar = () => {
  const { selectedQuestion, currentQuestion, currentAnswer, isLast, dispatch } = useQuizContext()

  return (
    <Root>
      <NavButton
        fw="bold"
        fs="textSmall"
        onClick={() => previousQuestion(dispatch)}
        enabled={selectedQuestion !== 0}
        show={selectedQuestion !== 0}
      >
        <span>Previous</span>
      </NavButton>
      <NavButton
        fw="bold"
        fs="textSmall"
        onClick={() => nextQuestion(dispatch)}
        enabled={canNavigate(currentAnswer, currentQuestion.questionType)}
        show={true}
      >
        <span>{isLast ? 'Finish quiz' : 'Next'}</span>
      </NavButton>
    </Root>
  )
}

export default NavigationBar
